import styled from "styled-components";

export const GridItem = styled.div<{ columnSpan: number }>`
  grid-column: 1 / span 12;

  @media (min-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-column: span ${({ columnSpan }) => columnSpan};
  }
`;

export const ResponsiveContainer = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacings.m} 0;
  display: grid;
  grid-template-columns:
    [full-start] repeat(2, 1fr)
    [content-start] repeat(8, 1fr)
    [content-end] repeat(2, 1fr)
    [full-end];
  grid-template-rows: max-content;
  gap: ${({ theme }) => theme.spacings.xs2};

  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    grid-template-columns: repeat(12, 1fr);
  }
`;

export const Grid = styled.div`
  grid-column: content-start / content-end;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: ${({ theme }) => theme.spacings.xs};
  grid-auto-rows: auto;
  align-items: start;
  align-content: start;
  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-column: 1 / -1;
    grid-template-columns: repeat(12, 1fr);
  }
`;
